import React, { useState } from "react";
import PropTypes from "prop-types";
import { NeoSideMenu, NeoSearch } from "../../../../components/Common";
import { GLOBAL_STATUS } from "../../../../constants/common";

/**
 * LevelSidebar
 * Lista de níveis utilizando o componente padronizado NeoSideMenu.
 */
const LevelSidebar = ({ levels = [], activeId, onSelect, onCreateNew, loading }) => {
    const [searchQuery, setSearchQuery] = useState("");

    // Filtrar níveis baseado na pesquisa local
    const filteredLevels = levels.filter((level) =>
        level.name?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // Mapear níveis para o formato de itens do NeoSideMenu
    const sideMenuItems = filteredLevels.map((level) => ({
        id: level.id,
        label: level.name,
        description: `Ordem: ${level.order ?? 0}`,
        badge: level.status === GLOBAL_STATUS.INACTIVE 
            ? "Inativo" 
            : level.value > 0 
                ? `${level.value} pts` 
                : null,
        badgeVariant: level.status === GLOBAL_STATUS.INACTIVE ? "muted" : "accent",
        icon: "mdi-stairs"
    }));

    return (
        <NeoSideMenu
            title="Níveis"
            subtitle="Graduação e progressão"
            icon="mdi-stairs"
            loading={loading}
            items={sideMenuItems}
            activeId={activeId}
            onSelect={(id) => {
                const level = levels.find((lvl) => lvl.id === id);
                if (level) onSelect(level);
            }}
            onAdd={onCreateNew}
            searchComponent={
                <NeoSearch
                    size="sm"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Buscar nível..."
                />
            }
        />
    );
};

LevelSidebar.propTypes = {
    levels: PropTypes.array,
    activeId: PropTypes.string,
    onSelect: PropTypes.func,
    onCreateNew: PropTypes.func,
    loading: PropTypes.bool,
};

export default LevelSidebar;
